import { SHOW_LOADER } from './../../action_types';

export const LoaderReducer = (state = false, action) => {
    switch (action.type) {
        case SHOW_LOADER:
            return action.payload;
        default:
            return state;
    }
}